import React  from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedMedianCalculator from './SharedMedianCalculator';
const TITLE = 'Median Calculator - Calculate the Median';
const DESCRIPTION = 'The Median Calculator calculates the median and explains the method of calculation.';
const KEYWORDS = 'Calculate the Median';
const OG_URL = 'https://do-calculate.com/calculator/en/median';
function Calculator() {
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                            Median: It is one of the measures of central tendency in statistics. It calculates the value that falls in the middle of the data, provided that the number of values less than it is equal to the number of values greater than it.
                                            <br />
                                            <ul>
                                                <li>
                                                    1. Arrange the data in ascending or descending order.
                                                </li>
                                                <li>
                                                    2. If the number of data is odd, the median is the value that is at position (number of data + 1) ÷ 2, which means the median is (n+1/2).
                                                </li>
                                                <li>
                                                    3. If the number of data is even, the median is the average of the two values at positions (n/2) and (n+2/2).
                                                </li>
                                            </ul>
                                            <b>
                                                You can also use the electronic calculator below to calculate the median value.
                                            </b>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <SharedMedianCalculator />
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.mathCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <br />
        </div>
    );
}
export default Calculator;
